// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPaymentDetailsStyles } from "@west/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { color, hideElement } from "@west/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 20,
};

onePageCheckoutPaymentDetailsStyles.form = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.poNumberGridItem = {
    width: [12, 12, 6, 7, 7],
};

onePageCheckoutPaymentDetailsStyles.poNumberText = {
    cssOverrides: {
        formField: css`
            max-width: 430px;
            margin-left: auto;
        `,
    },
};

onePageCheckoutPaymentDetailsStyles.paymentMethodGridItem = {
    width: [12, 12, 6, 5, 5],
    css: css`
        flex-direction: column;
        gap: 12px;
    `,
};

onePageCheckoutPaymentDetailsStyles.creditCardDetailsGridItem = {
    width: [12, 12, 6, 5, 5],
    css: css`
        max-width: 430px;
        flex-direction: column;
    `,
};

onePageCheckoutPaymentDetailsStyles.creditCardDetailsTitle = {
    variant: "h4",
    css: css`
        margin-top: 10px;
        margin-bottom: 15px;
    `,
};

onePageCheckoutPaymentDetailsStyles.saveAndContinueButtonGridItem = {
    css: css`
        ${hideElement}
    `,
};
